import { getItem, setItem } from '@/features/shared/utils/localStorage'
import { hoursToMilliseconds } from 'date-fns'

export function setSeenC360Element(element: 'banner' | 'toast', storeId: number) {
  setItem(`trident_${element}_${storeId}`, new Date().toISOString())
}

export function getIsC360ElementExpired(element: 'banner' | 'toast', storeId: number) {
  const strTimestamp = getItem(`trident_${element}_${storeId}`)
  if (!strTimestamp) {
    return true
  }
  const timestamp = new Date(strTimestamp).getTime()
  if (Number.isNaN(timestamp)) {
    return true
  }
  const diff = new Date().getTime() - timestamp
  return diff > hoursToMilliseconds(24)
}
